import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { AuthContainerProps } from "../../interfaces/containers";
import { cleanBranch, cleanConcessionary } from "../../actions/profile";
import NavBar from "../../components/NavBar/NavBar";
import { setPublicationForNews } from "../../actions/myPublications";
import { cleanVariants, setDataSheet } from "../../actions/salePost";
import { getAdminBrand } from "../../actions/auth";
import {
    downloadUsedVehicleTemplate,
    downloadNewVehicleTemplate,
    bulkUploadVehicles,
    bulkUploadImages,
    validateUploadStatus,
    cleanMassiveCharge,
    bulkUploadImagesStorage,
    confirmUploadProcess
} from '../../actions/massiveCharge';

function mapStateToProps(state: AuthContainerProps) {
    return{
        user: state.auth.user,
        concessionary: state.auth.concessionary,
        notifications: state.notifications.notifications,
        branch: state.profile.branch,
        adminBrand: state.auth.adminBrand,
        massiveCharge: {
            ...state.massiveCharge,
            // Aseguramos que uploadProgress siempre esté presente
            uploadProgress: state.massiveCharge.uploadProgress || 0
        }
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        cleanBranch,
        cleanConcessionary,
        setPublicationForNews,
        cleanVariants,
        bulkUploadImagesStorage,
        setDataSheet,
        getAdminBrand,
        downloadUsedVehicleTemplate,
        downloadNewVehicleTemplate,
        bulkUploadVehicles,
        bulkUploadImages,
        validateUploadStatus,
        cleanMassiveCharge,
        confirmUploadProcess
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);